export function getCookie(name)
{
    let value = document.cookie;
    let start = value.indexOf(' ' + name + '=');
    if(start === -1)
        start = value.indexOf(name + '=');
    if(start === -1)
        value = null;
    else
    {
        start = value.indexOf('=', start) + 1;
        let end = value.indexOf(';', start);
        if(end === -1)
            end = value.length;
        value = decodeURIComponent(value.substring(start, end));
    }
    return value;
}

export function setCookie(name, value, expireDays)
{
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() + expireDays);

    const cValue = encodeURIComponent(value) + (expireDays === null ? '' : '; expires=' + expireDate.toUTCString());
    document.cookie = name + '=' + cValue;
}

export function leadingZero(number)
{
    return number > 0 && number < 10 ? '0' + number : String(number);
}

export function formatDate(date, format = 'Y-m-d')
{
    if(!(date instanceof Date))
        date = new Date(date);

    return format
        .replace(/d/g, leadingZero(date.getDate()))
        .replace(/m/g, leadingZero(date.getMonth() + 1))
        .replace(/Y/g, String(date.getFullYear()));
}

export function encodeFormData(data)
{
    return Object.entries(data).map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value)).join('&');
}


